(() => {
  if (window.awCinemaReady) return;
  window.awCinemaReady = true;
  const states = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const paused = () => reduced.matches || document.documentElement.classList.contains('aw-motion-off');
  let scrollFrame = 0;
  function updateScroll() {
    scrollFrame = 0;
    states.forEach(({stage}) => {
      const rect = stage.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < innerHeight) stage.style.setProperty('--aw-hero-scroll', paused() ? '0' : String(Math.min(1, Math.max(0, -rect.top / rect.height))));
    });
  }
  function setup(root = document) {
    root.querySelectorAll('[data-aw-cinema]').forEach(stage => {
      if (states.has(stage)) return;
      const video = stage.querySelector('[data-aw-campaign-video]');
      const cues = [...stage.querySelectorAll('[data-aw-film-cue]')];
      const state = {stage, video, cues, timer: 0, visible: true};
      states.set(stage, state);
      video.loop = false;
      const heading = stage.querySelector('h1');
      const lines = heading.innerHTML.split(/<br\s*\/?\s*>/i).map(line => {
        const outer = document.createElement('span'); outer.className = 'aw-cinema-line';
        const inner = document.createElement('span'); inner.innerHTML = line; outer.append(inner); return outer;
      });
      heading.replaceChildren(...lines);
      if (!paused()) stage.classList.add('aw-cinema-enter');
      function progress() {
        const fraction = video.duration ? Math.min(1, video.currentTime / video.duration) : 0;
        const value = paused() ? 1 : fraction;
        cues.forEach((button, i) => {
          const start = Number(button.dataset.awFilmCue);
          const end = Number(cues[i + 1]?.dataset.awFilmCue ?? 1);
          const active = value >= start && (value < end || i === cues.length - 1);
          button.setAttribute('aria-pressed', String(active));
          button.style.setProperty('--aw-cue-progress', String(Math.min(1, Math.max(0, (value - start) / (end - start)))));
          button.disabled = paused() || !Number.isFinite(video.duration);
        });
      }
      cues.forEach(button => button.addEventListener('click', () => {
        if (!Number.isFinite(video.duration) || paused()) return;
        clearTimeout(state.timer); delete video.dataset.awReplayHold;
        video.currentTime = Number(button.dataset.awFilmCue) * video.duration;
        video.play().catch(() => {}); progress();
      }));
      video.addEventListener('timeupdate', progress);
      video.addEventListener('loadedmetadata', progress);
      video.addEventListener('ended', () => {
        video.dataset.awReplayHold = '1';
        clearTimeout(state.timer);
        // The final adorned poster bridges the end and the next optical reveal.
        state.timer = setTimeout(() => {
          if (paused() || document.hidden || !state.visible) return;
          video.classList.remove('aw-film-ready');
          state.timer = setTimeout(() => {
            delete video.dataset.awReplayHold;
            video.currentTime = 0;
            if (!paused() && !document.hidden && state.visible) video.play().catch(() => {});
          }, 750);
        }, 2200);
      });
      stage.addEventListener('pointermove', event => {
        if (!fine.matches || paused()) return;
        const rect = stage.getBoundingClientRect();
        stage.style.setProperty('--aw-depth-x', `${((event.clientX - rect.left) / rect.width - .5) * -10}px`);
        stage.style.setProperty('--aw-depth-y', `${((event.clientY - rect.top) / rect.height - .5) * -6}px`);
      }, {passive: true});
      stage.addEventListener('pointerleave', () => {stage.style.setProperty('--aw-depth-x', '0px'); stage.style.setProperty('--aw-depth-y', '0px');});
      const observer = new IntersectionObserver(([entry]) => {
        state.visible = entry.isIntersecting;
        stage.classList.toggle('aw-cinema-away', !entry.isIntersecting);
        if (!entry.isIntersecting) {clearTimeout(state.timer); delete video.dataset.awReplayHold;}
      }, {threshold: .05});
      observer.observe(stage); state.observer = observer;
      const ctaObserver = new IntersectionObserver(([entry]) => stage.classList.toggle('aw-cinema-cta-visible', entry.isIntersecting), {threshold:.65});
      const cta = stage.querySelector('.aw-ai-primary'); if (cta) ctaObserver.observe(cta); state.ctaObserver = ctaObserver;
      state.progress = progress; progress();
    });
  }
  document.addEventListener('aw:motion-change', () => states.forEach(state => {
    clearTimeout(state.timer); delete state.video.dataset.awReplayHold;
    state.progress(); updateScroll();
  }));
  addEventListener('scroll', () => {if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScroll);}, {passive:true});
  document.addEventListener('visibilitychange', () => {
    states.forEach(state => {stageVisibility(state);});
  });
  function stageVisibility(state) {
    state.stage.classList.toggle('aw-cinema-away', document.hidden || !state.visible);
    if (document.hidden) {clearTimeout(state.timer); delete state.video.dataset.awReplayHold;}
  }
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, stage) => {if (event.target.contains(stage)) {clearTimeout(state.timer); state.observer.disconnect(); state.ctaObserver?.disconnect(); states.delete(stage);}});
  });
  setup();
})();
